/* ImVita — drop-in photography.
   Turns every .ph placeholder into a drag-and-drop / click-to-upload slot.
   Images are downscaled and persisted in localStorage, keyed per page + slot. */
(function () {
  'use strict';
  var PAGE = (location.pathname.split('/').pop() || 'index') ;
  var MAX = 1600; // max edge px before storing

  function keyFor(el, i) {
    return 'imv-photo:' + PAGE + ':' + (el.getAttribute('data-img') || el.getAttribute('data-label') || 'ph') + ':' + i;
  }
  function apply(el, url) {
    el.style.backgroundImage = 'url("' + url + '")';
    el.classList.add('has-img');
  }
  function clearImg(el, key) {
    el.style.backgroundImage = '';
    el.classList.remove('has-img');
    try { localStorage.removeItem(key); } catch (e) {}
  }
  function downscale(file, cb) {
    var img = new Image();
    var fr = new FileReader();
    fr.onload = function () {
      img.onload = function () {
        var w = img.width, h = img.height;
        var scale = Math.min(1, MAX / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * scale); c.height = Math.round(h * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        cb(c.toDataURL('image/jpeg', 0.82));
      };
      img.src = fr.result;
    };
    fr.readAsDataURL(file);
  }
  function set(file, el, key) {
    if (!file || !/^image\//.test(file.type)) return;
    downscale(file, function (url) {
      apply(el, url);
      try { localStorage.setItem(key, url); }
      catch (e) { /* quota — image still shows for this session */ }
    });
  }
  function pick(el, key) {
    var inp = document.createElement('input');
    inp.type = 'file'; inp.accept = 'image/*';
    inp.style.display = 'none';
    inp.addEventListener('change', function () { if (inp.files[0]) set(inp.files[0], el, key); inp.remove(); });
    document.body.appendChild(inp); inp.click();
  }

  document.querySelectorAll('.ph').forEach(function (el, i) {
    var key = keyFor(el, i);
    try { var saved = localStorage.getItem(key); if (saved) apply(el, saved); } catch (e) {}

    el.addEventListener('dragover', function (e) { e.preventDefault(); el.classList.add('drag'); });
    el.addEventListener('dragleave', function () { el.classList.remove('drag'); });
    el.addEventListener('drop', function (e) {
      e.preventDefault(); el.classList.remove('drag');
      if (e.dataTransfer && e.dataTransfer.files[0]) set(e.dataTransfer.files[0], el, key);
    });

    // click-to-browse, except where a click means something else
    var interactive = el.closest('a') || el.closest('[data-ba]') || el.closest('.media') || el.hasAttribute('data-thumb');
    if (!interactive) {
      el.classList.add('ph-clickable');
      el.setAttribute('title', 'Click or drop an image to replace this placeholder');
      el.addEventListener('click', function () { pick(el, key); });
      // right-click to clear
      el.addEventListener('contextmenu', function (e) {
        if (el.classList.contains('has-img')) { e.preventDefault(); clearImg(el, key); }
      });
    }
  });
})();
